import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { LaboratoryType } from "../../app/types/genericTables.types";

type UseLaboratoryType = {
  laboratoriesList: LaboratoryType[];
  get: (id: LaboratoryType["id"]) => LaboratoryType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useLaboratory = create<UseLaboratoryType>((set, get) => ({
  loading: false,
  laboratoriesList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) =>
    get().laboratoriesList.find((laboratory) => laboratory.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Laboratorio";
      const { data: response } = await getData(endpoint);
      set(() => ({
        laboratoriesList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching laboratoriesList:", error);
      set({ loading: false });
    }
  },
}));
